
import { Card, CardContent } from "@/components/ui/card";
import { Euro } from "lucide-react";
import { useTranslations } from "@/hooks/useTranslations";

interface PricingCardProps {
  showPrices: boolean;
  hourlyRate?: number;
}

export const PricingCard = ({ showPrices, hourlyRate }: PricingCardProps) => {
  const { t } = useTranslations("publicProfile");
  
  if (!showPrices || !hourlyRate) return null;
  
  return (
    <Card className="border-none shadow-lg bg-gradient-to-br from-gray-200 to-white dark:from-gray-800 dark:to-gray-900 h-full">
      <CardContent className="p-6">
        <div className="flex items-center gap-2 mb-4">
          <Euro className="h-5 w-5 text-gray-700 dark:text-gray-300" />
          <h2 className="text-xl font-semibold text-gray-900 dark:text-gray-100">{t("prices")}</h2>
        </div>
        
        <div className="flex flex-col items-center justify-center mt-4 p-6 bg-white/80 dark:bg-gray-800/80 rounded-xl shadow-inner">
          <span className="text-sm text-muted-foreground dark:text-gray-400">{t("hourlyRate")}</span>
          <div className="flex items-center mt-2">
            <span className="text-4xl font-bold text-gray-700 dark:text-gray-200 tracking-tight">
              €{hourlyRate}
            </span>
            <span className="text-lg text-muted-foreground dark:text-gray-400 ml-1">{t("perHour")}</span>
          </div>
          
          <div className="mt-6 bg-gray-200 dark:bg-gray-700 p-3 rounded-lg text-center w-full">
            <p className="text-sm text-gray-700 dark:text-gray-300">{t("checkAvailability")}</p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
